import { toast } from 'react-toastify';
import { format } from 'date-fns';
import $ from 'jquery';
import countryList from "react-select-country-list";

var config = {
    autoClose: 2000,
    closeOnClick: true,
    pauseOnHover: false,
}

const Helper = {
    validationError: (json) => {
        $('.validationAlert').empty();
        $('.input-wrap').removeClass('error');
        if (json.errors !== undefined && typeof json['errors'] === 'object') {
            Object.entries(json['errors']).forEach(([key, val]) => {
                var ele = $(`[name="${key}"]`);
                if (ele.length == 0) {
                    ele = $(`[id="${key}"]`);
                }

                if (ele.length > 0) {
                    var parent = ele.closest('.form-group');
                    parent.find('.validationAlert').text(val[0]);
                    parent.find('.input-wrap').addClass('error');
                }
            });
        } else if (json.success === true && json.message !== undefined && json.message) {
            toast.success(json.message, config);
        } else if (json.success === false && json.message !== undefined && json.message) {
            if (json.message == 'Unauthenticated Invalid Token' || json.message == 'The application not found.' || json.message == 'Token Expired') {
                localStorage.removeItem('user');
                localStorage.removeItem('formCount');
                Helper.success(json.message);
                window.location.href = '/';
            }
            toast.error(json.message, config);
        }
    },
    reviewError: (json) => {
        $('.validationAlert').empty();
        $('.field-wrapper').removeClass('error');

        if (json.errors !== undefined && typeof json['errors'] === 'object') {
            Object.entries(json['errors']).forEach(([key, val]) => {
                var ele = $(`.${key}`);
                if (ele.length == 0) ele = $(`[id="${key}"]`);

                if (ele.length > 0) {
                    ele.find('.validationAlert').text(val[0]);
                    ele.addClass('error');
                } else {
                    var stadd = ["address_1", "address_2", "suburb", "city", "country", "postal_code"];
                    if (stadd.indexOf(key) != -1) {
                        $('.street_address').find('.validationAlert').text('The street address field required.');
                        $('.street_address').addClass('error');
                    }

                    var pstadd = ["postal_address_1", "postal_address_2", "postal_suburb", "postal_city", "postal_country", "postal_postal_code"];
                    if (pstadd.indexOf(key) != -1) {
                        $('.postal_address').find('.validationAlert').text('The postal address field required.');
                        $('.postal_address').addClass('error');
                    }
                }
            });
        }
    },
    success: (message) => {
        toast.success(message, config);
    },
    error: (message) => {
        if (message == 'Unauthenticated Invalid Token' || message == 'The application not found.' || message == 'Token Expired') {
            localStorage.removeItem('user');
            localStorage.removeItem('formCount');
            window.location.href = '/';
        }
        toast.error(message, config);
    },
    ShowLoader: () => {
        return <div className="loader"></div>
    },
    dateFormat: (date, fm = 'dd/MM/yyyy h:m a') => {
        if (date == null || date == undefined) return '';
        var d = new Date(date);
        return format(d, fm);
    },
    findCountryByLabel: (label, countries = null) => {
        if (countries === null) {
            countries = countryList().getData();
        }
        return countries.find(country => country.label === label);
    },
    findByValue: (value, arr) => {
        return arr.find(country => country.value === value);
    },
    checkProperties: (obj) => {
        for (var key in obj) {
            if (obj[key] !== undefined && obj[key] !== null && obj[key] != "") return false;
        }
        return true;
    },
    fillApplication: (application, input) => {
        var data = input;
        data.status = application.status;
        data.is_user = 1;

        Object.keys(application).forEach(function (key) {
            if (application[key]) {
                if (application[key].constructor === String) {
                    data[key] = application[key] ?? '';
                }
                if (application[key].constructor === Object && Object.keys(application[key]).length > 0) {
                    for (let k in application[key]) {
                        if (input.hasOwnProperty(k)) data[k] = application[key][k] ?? '';
                    }
                }
                if (application[key].constructor === Array && application[key].length > 0) {
                    application[key].forEach((arr, i) => {
                        var prefix = arr.address_type && arr.address_type == 'P' ? 'postal_' : ''

                        for (let kk in arr) {
                            var kkk = `${prefix}${kk}`
                            if (input.hasOwnProperty(kkk)) {
                                data[kkk] = arr[kk] ?? ''
                            }
                        }
                    })
                }
                if (key == 'tax') {
                    var tax_details = [];
                    application[key].forEach((arr, i) => {
                        tax_details.push({ country_issue: arr.country_issue, tax_number: arr.tax_id_number })
                    });
                    data['tax_details'] = tax_details;
                }
            }
        });
        return data;
    },
    convertFormData: (obj) => {
        var formData = new FormData();
        for (var key in obj) {
            if (obj[key] instanceof Array && obj[key].length > 0) {
                obj[key].map((v, i) => {
                    if (v instanceof Array && v.length > 0) {
                        for (var vv in v) {
                            formData.append(`${key}[${i}][${vv}]`, v[vv]);
                        }
                    } else if (v instanceof Object && v) {
                        Object.keys(v).forEach((ii) => {
                            formData.append(`${key}[${i}][${ii}]`, v[ii]);
                        })
                    } else {
                        formData.append(`${key}[${i}]`, v);
                    }
                })
            } else if (obj[key] instanceof Object && obj[key]) {
                var v = obj[key]
                Object.keys(v).forEach((ii) => {
                    formData.append(`${key}[${ii}]`, v[ii]);
                })
            } else {
                formData.append(key, obj[key] ?? '');
            }
        }
        return formData;
    },
    checkObject: (obj) => {
        var total = 0;
        Object.keys(obj).forEach(function (key) {
            if (obj[key]) total++
        });
        return total;
    },
    objJoin: (obj) => {
        var str = {};
        Object.keys(obj).forEach(function (key) {
            if (obj[key]) str[key] = obj[key]
        });

        return Object.values(str).join(', ');
    }
}

export default Helper;
